import React from "react";
import { useTranslation } from "next-i18next";
import { TYPO } from "styles/Typo";
import CenterModal from "components/common/Modal/CenterModal";
import useModalClickOutside from "utils/useModalClickOutside";
import { useRouter } from "next/router";
import { STRATEGY_META, STRATEGY_TYPE } from "utils/constant/STATUS";
import { Forward } from "components/common/Icons";
import Button from "components/common/buttons/buttons";

export function StrategyRecommandModal({
  isModalOpen,
  setModalOpen,
  sCode,
}: {
  isModalOpen: boolean;
  setModalOpen: any;
  sCode: STRATEGY_TYPE;
}) {
  const modalRef = useModalClickOutside(setModalOpen);
  const router = useRouter();
  //    onClick={() => setModalOpen(!isModalOpen)}
  return (
    <CenterModal modalRef={modalRef} containerClass="!p-0 w-[327px]">
      <div className="py-2 flex flex-col gap-2">
        <div className="px-5 py-2 gap-3 items-center flex cursor-pointer ">
          <div className="flex flex-col justify-center items-center w-full">
            <span className={`${TYPO.TYPO5_1_SB}  text-gray80 `}>
              {"“"}
              {router.locale === "ko"
                ? STRATEGY_META[sCode].recommandSubtitle
                : STRATEGY_META[sCode].recommandSubtitleEng}
              {"”"}
            </span>
          </div>
        </div>
        <div className={` w-full`}>
          <div className=" py-2 px-5 flex flex-col">
            <div className="pl-5 flex flex-col gap-[5px] border-l-[2px] border-gray15 box-content">
              <span className={`${TYPO.TYPO7_RG} text-gray60 break-keep`}>
                {router.locale === "ko"
                  ? STRATEGY_META[sCode].recommandContentDesc1
                  : STRATEGY_META[sCode].recommandContentDescEng1}
              </span>
              <span className={`${TYPO.TYPO7_RG} text-gray60 break-keep`}>
                {router.locale === "ko"
                  ? STRATEGY_META[sCode].recommandContentDesc2
                  : STRATEGY_META[sCode].recommandContentDescEng2}
              </span>
              <span className={`${TYPO.TYPO7_RG} text-gray40`}>
                {router.locale === "ko"
                  ? STRATEGY_META[sCode].recommandContentTitle
                  : STRATEGY_META[sCode].recommandContentTitleEng}
              </span>
            </div>
          </div>
        </div>
        <div className="px-5 py-2 w-full">
          <Button
            size="md"
            text={router.locale === "ko" ? "확인" : "Confirm"}
            clickHandler={() => setModalOpen(!isModalOpen)}
            type={"tertiary"}
            width="w-full"
          />
        </div>
      </div>
    </CenterModal>
  );
}

export default StrategyRecommandModal;
